export default "__VITE_ASSET__DULnFeZX__"